export const i19a = 'the'
export const i19about = 'About'
export const i19aboutCvvMsg = '3 or 4 digits, usually on the back of the card (up front on AMEX cards)'
export const i19aboveOf = 'Above of'
export const i19acceptAttachedFile = 'Accept attached file'
export const i19acceptCustomOptionByCustomer = 'Accept custom option by customer'
export const i19activate = 'Ativate'
export const i19active = 'Active'
export const i19add = 'Add'
export const i19addApp = 'Add app'
export const i19addCart = 'Add cart'
export const i19addClient = 'Add client'
export const i19addDiscountCoupon = 'Add discount coupon'
export const i19addGiftList = 'Add gift list'
export const i19addGrid = 'Add grid'
export const i19additional = 'Additional'
export const i19additionalComments = 'Additional comments'
export const i19additionalCost = 'Additional cost'
export const i19additionalCostOption = 'Options additional cost'
export const i19additionalInfo = 'Additional info'
export const i19additionalNotes = 'Additional notes'
export const i19address = 'Address'
export const i19addresses = 'Addresses'
export const i19addressesName = 'Recipient'
export const i19addMoreProducts = 'Add more products'
export const i19addPreference = 'Add preference'
export const i19addProduct = 'Add product'
export const i19addToCart = 'Add to cart'
export const i19addToFavorites = 'Add to favorites'
export const i19addToPrice = 'Add to price'
export const i19addVariants = 'Add variants'
export const i19add$1ToEarn = 'Add $1 to earn'
export const i19adminSettings = 'Admin Settings'
export const i19adRelevance = 'Ad relevance'
export const i19adType = 'Ad type'
export const i19advanced = 'Advanced'
export const i19adwords = 'Adwords'
export const i19adwordsRemarketing = 'AdWords Remarketing'
export const i19adwordsRemarketingCode = 'AdWords Remarketing Code'
export const i19affiliateCoede = 'Afiliate code'
export const i19afterApproval = 'After payment approval'
export const i19afterPayment = 'After payment'
export const i19all = 'All'
export const i19allCategories = 'All categories'
export const i19allOptions = 'All options'
export const i19alt = 'Alt tag'
export const i19amount = 'Amount'
export const i19another = 'Another'
export const i19anyPaymentMethodMsg = 'Any available payment method.'
export const i19api = 'Api'
export const i19app = 'App'
export const i19appAlreadyInstalledMsg = 'The application is already installed, do you want to duplicate it?'
export const i19appConfiguration = 'App configuration'
export const i19apps = 'Apps'
export const i19appDevelopers = 'App developers'
export const i19application = 'Application'
export const i19applications = 'Applications'
export const i19applyDiscount = 'Apply discount'
export const i19applyFilters = 'Apply filters'
export const i19areYouWantToDeleteAppQn = 'Are you sure you want to delete the app?'
export const i19associateImage = 'Associate image'
export const i19associateImages = 'Associate images'
export const i19asOf = 'As of'
export const i19at = 'At'
export const i19atSight = 'At sight'
export const i19attachment = 'Attachment'
export const i19attention = 'Attention'
export const i19authentication = 'Authentication'
export const i19author = 'Author'
export const i19authorizedStores = 'Authorized storest'
export const i19automaticallyTrackInventory = 'Automatically track inventory'
export const i19available = 'Available'
export const i19availablePurchase = 'Available for purchase'
export const i19availableApps = 'Available apps'
export const i19average = 'Average'
export const i19averageTicket = 'Average ticket'
export const i19back = 'Back'
export const i19backToCart = 'Back to cart'
export const i19backToProduct = 'Back to product'
export const i19bag = 'Bag'
export const i19balanceOrPoints = 'Balance or points'
export const i19banner = 'Banner'
export const i19banners = 'Banners'
export const i19bannersCollection = 'Collection banners'
export const i19barcodes = 'Barcodes'
export const i19basePrice = 'Base price'
export const i19bearersDocument = 'Bearer\'s document'
export const i19best = 'Best'
export const i19bestSellers = 'Best sellers'
export const i19biannual = 'Biannual'
export const i19billingAddress = 'Billing address'
export const i19bimonthly = 'Bimonthly'
export const i19birthdate = 'Birthdate'
export const i19biweekly = 'Biweekly'
export const i19block = 'Block'
export const i19borough = 'Borough'
export const i19budgetOnly = 'Only budget'
export const i19buy = 'Buy'
export const i19buyAgain = 'Buy again'
export const i19buyAlsoMsg = 'Enjoy and buy also'
export const i19buyer = 'Buyer'
export const i19buyers = 'Buyers'
export const i19buyersProfile = 'Buyers profile'
export const i19buyNow = 'Buy now'
export const i19buyKit = 'Buy kit'
export const i19by = 'by'
export const i19brand = 'Brand'
export const i19brandBanners = 'Brand banners'
export const i19brandName = 'Brand name'
export const i19brandFound = 'Brand found'
export const i19brands = 'Brands'
export const i19brandsFound = 'Brands found'
export const i19brazil = 'Brazil'
export const i19browserIp = 'IP address of the browser'
export const i19buyWith = 'Frequently bought together'
export const i19calculateShipping = 'Calculate shipping'
export const i19callTo = 'Call to'
export const i19callback = 'Callback'
export const i19campaign = 'Campaign'
export const i19campaignAppliedMsg = 'Discount campaign successfully applied.'
export const i19cancel = 'Cancel'
export const i19cancelled = 'Cancelled'
export const i19cancelledAt = 'Cancelled at'
export const i19cancelOrder = 'Cancel order'
export const i19cancelReason = 'Cancel reason'
export const i19cardNumber = 'Card number'
export const i19cartConfirmed = 'Cart confirmed'
export const i19cartDetails = 'Cart details'
export const i19cartItems = 'Cart items'
export const i19cartReview = 'Cart review'
export const i19cartUpdated = 'Cart updated'
export const i19categories = 'Categories'
export const i19category = 'Category'
export const i19categoryBanners = 'Category banner'
export const i19categoryFound = 'Category found'
export const i19categoryName = 'Category name'
export const i19cellphone = 'Cellphone'
export const i19changePaymentMethod = 'Change payment method'
export const i19changeShippingMethod = 'Change shipping method'
export const i19channel = 'Channel'
export const i19channelId = 'Channel ID'
export const i19channels = 'Channels'
export const i19channelType = 'Channel type'
export const i19checkout = 'Checkout'
export const i19checkoutEnabled = 'Checkout enabled'
export const i19checkoutDone = 'Checkout done'
export const i19checkoutLink = 'Checkout link'
export const i19checkoutMobileLink = 'Checkout link mobile'
export const i19checkoutVisitor = 'Checkout visitor'
export const i19checkoutVisitorMsg = 'You can also buy as a visitor if you prefer'
export const i19chooseSubscriptionPeriod = 'Choose subscription period'
export const i19city = 'City'
export const i19clear = 'Clear'
export const i19clearFilters = 'Clear filters'
export const i19click = 'Click'
export const i19clickHere = 'Click here'
export const i19close = 'Close'
export const i19closedAt = 'Closed at'
export const i19closeFilters = 'Close filters'
export const i19code = 'Code'
export const i19codeCopied = 'Code copied'
export const i19collection = 'Collection'
export const i19collections = 'Collections'
export const i19collectionBanners = 'Collection banner'
export const i19collectionItems = 'Collection items'
export const i19collectionName = 'Collection name'
export const i19color = 'Color'
export const i19colors = 'Colors'
export const i19community = 'Community'
export const i19companyRegistration = 'Company registration'
export const i19compareAtPrice = 'Compare at price'
export const i19compareProducts = 'Compare with similar items'
export const i19comparedPreviousPeriodMsg = 'Compared to the previous period (same number of days).'
export const i19complement = 'Complement'
export const i19complementInformation = 'Complement Information'
export const i19connectionErrorMsg = 'Connection error, try again'
export const i19connectionErrorProductMsg = 'Connection error, click product to try again'
export const i19configuration = 'Configuration'
export const i19confirmPassword = 'Confirm password'
export const i19confirmPurchase = 'Confirm purchase'
export const i19contactPhone = 'Contact phone'
export const i19contactUsMsg = 'If you have any questions, please contact us.'
export const i19content = 'Content'
export const i19continue = 'Continue'
export const i19continueLoginOnPopup = 'Continue login on popup'
export const i19continueShopping = 'Continue shopping'
export const i19control = 'Control'
export const i19copyCode = 'Copy code'
export const i19copyErrorMsg = 'Error copying to clipboard, please copy manually'
export const i19copyright = 'Copyright'
export const i19corporateName = 'Corporate name'
export const i19costDeclaredValue = 'Cost for "declared value"'
export const i19costPrice = 'Cost price'
export const i19countryCode = 'Country code'
export const i19couponAppliedMsg = 'Discount coupon successfully applied.'
export const i19createTransaction = 'Create transaction'
export const i19creation = 'Creation'
export const i19credit = 'Credit'
export const i19creditCard = 'Credit card'
export const i19creditCardBin = 'Credit card issuer identification'
export const i19creditCardCompany = 'Credit card issuer'
export const i19creditCardHolderName = 'Full name on credit card'
export const i19creditCardLastDigits = 'Last digits from credit card'
export const i19creditorFees = 'Creditor fees'
export const i19creditorFeesIntermediator = 'Intermediator fee'
export const i19creditorFeesOperational = 'Operational fee'
export const i19currencyId = 'Currency Identifier'
export const i19currencySymbol = 'Currency symbol'
export const i19custom = 'Customize'
export const i19customer = 'Customer'
export const i19customerNotified = 'Customer already notified'
export const i19customerService = 'Customer service'
export const i19customFields = 'Custom fields'
export const i19customizationAddToPrice = 'Price due to customization'
export const i19customizationAttachment = 'Attach Custom File'
export const i19customizationChosen = 'Customization chosen'
export const i19customizations = 'Customizations'
export const i19customPayment = 'Custom payment'
export const i19customValue = 'Custom value'
export const i19dashboard = 'Dashboard'
export const i19dateTime = 'Date and time (ISO 8601)'
export const i19danger = 'Danger'
export const i19day = 'Day'
export const i19dailyAverage = 'Daily average'
export const i19days = 'Days'
export const i19declare = 'Declare'
export const i19declaredValue = 'Declared value'
export const i19delete = 'Delete'
export const i19deleteAll = 'Delete all'
export const i19delivery = 'Delivery'
export const i19deliveryCostOwnHandMsg = 'Cost for the "own hand" additional service'
export const i19deliveryInMsg = 'Your order will be delivered within'
export const i19deliveryReceipt = 'Delivery receipt'
export const i19deliveryReceiptMsg = 'Delivered with acknowledgment of receipt'
export const i19deliveryTrack = 'Delivery Track'
export const i19deliveryTime = 'Delivery time'
export const i19deliveryWithOwnHandMsg = 'Delivery with additional service "own hand"'
export const i19description = 'Description'
export const i19desktop = 'Desktop'
export const i19details = 'Details'
export const i19didYouMean = 'Did you mean'
export const i19digits = 'Digits'
export const i19directLinkPayment = 'Direct link to payment'
export const i19disable = 'Disable'
export const i19discount = 'Discount'
export const i19discountCoupon = 'Discount coupon'
export const i19discountOf = 'Discount of'
export const i19discountValueMsg = 'Discount value, percentage or fixed'
export const i19displayName = 'Display name'
export const i19docCountry = 'Country of document origin'
export const i19docNumber = 'Document number'
export const i19docs = 'Docs'
export const i19domain = 'Domain'
export const i19doPaymentMsg = 'Please finalize the payment to confirm your purchase'
export const i19doYouWantToDeleteAppQn = 'Are you sure you want to delete the app?'
export const i19doYouWantToReinstallAppQn = 'Are you sure you want to reinstall the app?'
export const i19download = 'Download'
export const i19downloadTable = 'Download table'
export const i19edit = 'Edit'
export const i19editing = 'Editing'
export const i19editAdditionalCost = 'Edit additional cost'
export const i19editComments = 'Edit comments'
export const i19editDispatchAndFulfillment = 'Edit dispatch and fulfillment'
export const i19editFeatures = 'Edit features'
export const i19editFilters = 'Edit filters'
export const i19editGtinMpn = 'Edit GTIN and MPN'
export const i19editHtmlDescription = 'Edit HTML description'
export const i19editObservationInfo = 'Edit observation info'
export const i19editPaymentDetails = 'Edit payment details'
export const i19editProductDimensions = 'Edit product dimensions'
export const i19editSeoFields = 'Edit SEO fields'
export const i19editStorefront = 'Edit storefront'
export const i19editVariation = 'Edit variation'
export const i19email = 'Email'
export const i19emailAddress = 'Email address'
export const i19emailCartTextMsg = 'You can finish it now, while the cart is available.'
export const i19emailCartTitleMsg = 'You did not finish your purchase!'
export const i19emailDeliveredTextMsg = 'We hope you have enjoyed shopping with us and will soon visit our website again. The order was delivered to the address below'
export const i19emailDeliveredTitleMsg = 'Your package was delivered!'
export const i19emailInfoMsg = 'Any update to the order will be notified by email, you can also track the progress through'
export const i19emailMarketing = 'Email marketing'
export const i19emailMarketingOptInMsg = 'I want to receive offers and content from the store by email.'
export const i19emailProfileNotFound = 'No profile found with this email address'
export const i19emails = 'Emails'
export const i19emailShippedTextMsg = 'Your package is now with the carrier. To track the delivery progress, go to'
export const i19emailShippedTitleMsg = 'Your package is on the way!'
export const i19empty = 'Empty'
export const i19emptyCart = 'Empty shopping cart'
export const i19emptyCartMsg = 'Your shopping cart is empty'
export const i19enabled = 'Enabled'
export const i19end = 'End'
export const i19endDate = 'End date'
export const i19endpoint = 'Endpoint'
export const i19endsIn = 'Ends in'
export const i19enterEmailCodeMsg = 'Enter the verification code we send you by email.'
export const i19enterYourDocNumber = 'Enter your document number'
export const i19enterYourDocNumberMsg = 'Enter your document number to confirm'
export const i19enterYourEmail = 'Enter your email'
export const i19enterYourEmailMsg = 'Enter your email to proceed'
export const i19erp = 'ERP'
export const i19error = 'Error'
export const i19errorMsg = 'An error has occurred, try again or contact us.'
export const i19events = 'Events'
export const i19export = 'Export'
export const i19exportToCsv = 'Export to csv'
export const i19extra = 'Extra'
export const i19extraCost = 'Extra cost'
export const i19external = 'External'
export const i19familyName = 'Last name'
export const i19favorites = 'Favorites'
export const i19featuredApps = 'Featured apps'
export const i19female = 'Female'
export const i19field = 'Field'
export const i19files = 'Files'
export const i19filter = 'Filter'
export const i19filterProducts = 'Filter products'
export const i19filterResults = 'Filter results'
export const i19finalPrice = 'Final price'
export const i19finalPriceWithAdditional = 'Final price with additional'
export const i19financialStatus = 'Financial status'
export const i19firstSteps = 'First steps'
export const i19followingAddress = 'To the following address'
export const i19for = 'For'
export const i19free = 'Free'
export const i19freebie = 'Freebie'
export const i19freeShipping = 'Free shipping'
export const i19freeShippingFrom = 'Free shipping from'
export const i19freight = 'Freight'
export const i19freightCost = 'Freight cost'
export const i19from = 'From'
export const i19fulfillmentStatus = 'Fulfillment status'
export const i19fullName = 'Full name'
export const i19fullscreen = 'Fullscreen'
export const i19gateway = 'Gateway'
export const i19gender = 'Gender'
export const i19genderX = 'Other'
export const i19general = 'General'
export const i19generateBillet = 'Generate billet'
export const i19get = 'Get'
export const i19giftList = 'Gift list'
export const i19giftListAuthors = 'Authors of the list'
export const i19giftListAuthorsContact = 'Contact to list owners'
export const i19giftListDescription = 'Short text description for gift list'
export const i19giftListEventDate = 'Date of gift list'
export const i19giftListInformation = 'Informations gift list'
export const i19giftListNotificationPurchaseMsg = 'Email address to be notified after gift purchase'
export const i19giftListPermalink = 'URL to gift list page'
export const i19giftListTitle = 'Title for the gift list'
export const i19giftListValidThru = 'Validity of the list'
export const i19giftListOwnerID = 'Customer ID who will receive the gift'
export const i19giftListWaiting = 'Wait gift list for purchase'
export const i19giftTo = 'Gift to'
export const i19giftWrap = 'Gift wrap'
export const i19gitRepository = 'Github repository'
export const i19givenName = 'Given name'
export const i19goToCart = 'Go to cart'
export const i19goToStore = 'Go to store'
export const i19goToTop = 'Go to top'
export const i19googleAnalytics = 'Google Analytics'
export const i19googleProductCategoryId = 'Google product category ID'
export const i19gridId = 'Grid ID'
export const i19grids = 'Grids'
export const i19gridName = 'Grid name'
export const i19guestCheckoutMsg = 'If you prefer, you can also continue shopping as a visitor.'
export const i19hasCouponOrVoucherQn = 'Has coupon or voucher?'
export const i19height = 'Height'
export const i19hello = 'Hello'
export const i19helloAgain = 'Hello again'
export const i19help = 'Help'
export const i19helpful = 'Helpful'
export const i19high = 'High'
export const i19highestPrice = 'Highest price'
export const i19highPriority = 'High priority'
export const i19holderName = 'Holder name'
export const i19home = 'Home'
export const i19icon = 'Icon'
export const i19id = 'ID'
export const i19identification = 'Identification'
export const i19identifyYourAccount = 'Identify your account'
export const i19idOfShippingLine = 'ID of shipping line'
export const i19image = 'Image'
export const i19images = 'Imagens'
export const i19import = 'Import'
export const i19in = 'In'
export const i19inactive = 'Inactive'
export const i19incorrect = 'Incorrect'
export const i19incorrectFormat = 'Incorrect format'
export const i19incorrectEmailCodeMsg = 'Incorrect code, check the email sent to you, search for spam if necessary or wait a few moments if you haven\'t received it.'
export const i19info = 'Information'
export const i19inscriptionNumber = 'Inscription number'
export const i19insert = 'Insert'
export const i19install = 'Install'
export const i19installed = 'Installed'
export const i19installedApps = 'Installed apps'
export const i19installingApp = 'Installing app'
export const i19installment = 'Installment'
export const i19installments = 'Installments'
export const i19installNow = 'Install now'
export const i19inStock = 'In stock'
export const i19inStockAt = 'In stock at'
export const i19interestFree = 'Interest free'
export const i19intermediator = 'Intermediator'
export const i19invalidCard = 'Invalid card info'
export const i19invalidCardMsg = 'Unable to validate this card, please check the data or try again later.'
export const i19invalidCouponMsg = 'Discount coupon entered is invalid.'
export const i19invalidDomainName = 'Invalid domain name'
export const i19invalidLoginInfoMsg = 'Invalid login info, please verify.'
export const i19inventory = 'Inventory'
export const i19inventoryHistory = 'Recent history stock'
export const i19invoice = 'Invoice'
export const i19invoices = 'Invoices'
export const i19iReadAndAccept = 'I read and accept'
export const i19isFilter = 'Is filter'
export const i19isNotYou = 'Is not you'
export const i19item = 'Item'
export const i19items = 'Items'
export const i19itemsFound = 'Items found'
export const i19jurifical = 'Juridical'
export const i19just = 'Just'
export const i19keywords = 'Keywords'
export const i19kit = 'Kit'
export const i19label = 'Label'
export const i19LabelOfCustomization = 'Label of customization'
export const i19last = 'Last'
export const i19lastOptions = 'Last available options'
export const i19lastPurchase = 'Last purchase'
export const i19lastSearchedTerms = 'Last searched terms'
export const i19lastVisitedProducts = 'List of last products visited'
export const i19latestOrders = 'Latest orders'
export const i19launch = 'Launch'
export const i19launching = 'Launching'
export const i19length = 'Length'
export const i19lineAddress = 'Full address'
export const i19list = 'List'
export const i19listOfInvoices = 'List of invoices'
export const i19listOfPayments = 'List of payments'
export const i19listSubscriptionInvoices = 'List subscription invoices'
export const i19load = 'Load'
export const i19loadMore = 'Load more'
export const i19loading = 'Loading'
export const i19loadDataErrorMsg = 'Unable to load API data, please check your connection.'
export const i19loadProductErrorMsg = 'Unable to load product information, please check your internet connection.'
export const i19locale = 'Customer language'
export const i19login = 'Login'
export const i19loginEnabled = 'Login enabled'
export const i19loginErrorMsg = 'There was an error trying to login, please try again or select another option.'
export const i19loginForOrderDetailsMsg = 'Login with the buyer\'s account to access more order details.'
export const i19logo = 'Logo'
export const i19logout = 'Logout'
export const i19low = 'Low'
export const i19lowestPrice = 'Lowest price'
export const i19loyaltyPoints = 'Loyalty points'
export const i19loyaltyPointsName = 'The name of the loyalty points program'
export const i19loyaltyPointsPointsValue = 'Number of loyalty points received'
export const i19madeBy = 'Made by'
export const i19mainEmail = 'Main email'
export const i19male = 'Male'
export const i19manageStock = 'Manage stock'
export const i19manageYourPurchaseHistory = 'Manage your purchase history'
export const i19marketing = 'Marketing'
export const i19marketplace = 'Marketplace'
export const i19marketplaces = 'Marketplaces'
export const i19massEdit = 'Mass edit'
export const i19maximum = 'Maximum'
export const i19maxQuantity = 'Max quantity'
export const i19measurement = 'Measure a dimension of your product'
export const i19media = 'Media'
export const i19mediaGallery = 'Media gallery'
export const i19menu = 'Menu'
export const i19metafields = 'Metafields'
export const i19metafieldsMsg = 'List of custom attributes'
export const i19metaTagDescription = 'Meta description tag'
export const i19middleName = 'Middle name'
export const i19minimum = 'Minimum'
export const i19minQuantity = 'Minimum quantity'
export const i19mlCategoryId = 'ML Category ID'
export const i19mobile = 'Mobile'
export const i19mobileLink = 'Link to mobile devices'
export const i19modules = 'Modules'
export const i19month = 'Month'
export const i19monthly = 'Monthly'
export const i19mostPopular = 'Most Popular'
export const i19mostRelevant = 'Most Relevant'
export const i19motorcycleCourier = 'Motorcycle courier'
export const i19myAccount = 'My account'
export const i19myAccountAndOrders = 'My account and orders'
export const i19myCart = 'My cart'
export const i19myFavorites = 'My favorites'
export const i19myOrders = 'My orders'
export const i19myShoppingCart = 'My shopping cart'
export const i19name = 'Name'
export const i19nameOnCard = 'Name on card'
export const i19namespace = 'Namespace'
export const i19namespaceMsg = 'String to help distinguish who (or which app) created and can use this'
export const i19nearTo = 'Reference for this address'
export const i19needHelpQn = 'Need help?'
export const i19new = 'New'
export const i19newAddress = 'New address'
export const i19newOrders = 'New orders'
export const i19newPassword = 'New password'
export const i19newPriceRange = 'New price range'
export const i19newsletter = 'Newsletter'
export const i19newsletterReport = 'Newsletter report'
export const i19newVersionAvailableMsg = 'There is a new version for this application, reinstall to update.'
export const i19next = 'Next'
export const i19nickname = 'Nickname'
export const i19no = 'No'
export const i19noAdditional = 'No additional'
export const i19noAppsAvailable = 'No apps available'
export const i19noBrand = 'No brand found'
export const i19noCategory = 'No category found'
export const i19noCollection = 'No collection found'
export const i19noGrid = 'No grid found'
export const i19noItemSelected = 'No item selected'
export const i19noNewOrdersMsg = 'No new orders for now.'
export const i19noNumber = 'No number'
export const i19noOrder = 'No order found'
export const i19noPrice = 'No price'
export const i19noProduct = 'No product found'
export const i19noProfileFoundWithEmail = 'No profile found with email'
export const i19noResultsFor = 'No results for'
export const i19normal = 'Normal'
export const i19noSavedFavoritesMsg = 'You don\'t have any products saved as favorites yet.'
export const i19notConfigured = 'Not configured'
export const i19notFound = 'Not found'
export const i19notifications = 'Notifications'
export const i19notified = 'Notified'
export const i19notifiedAdmins = 'Notified admin'
export const i19notifiedAdminsMsg = 'List of administrators that already seen current status change'
export const i19notifyAboutOrders = 'Notify about progress of the order'
export const i19notes = 'Notes'
export const i19noUser = 'No user found'
export const i19number = 'Number'
export const i19oauthOnPopup = 'Login in to pop-up'
export const i19of = 'Of'
export const i19ofDiscount = 'Of discount'
export const i19offer = 'Offer'
export const i19on = 'On'
export const i19onFreight = 'On freight'
export const i19onFollowingAddress = 'On the following address'
export const i19only = 'Only'
export const i19open = 'Open'
export const i19openAt = 'Open at'
export const i19openCart = 'Open cart'
export const i19openGallery = 'Open gallery'
export const i19operational = 'Operational'
export const i19option = 'Option'
export const i19optionChosen = 'Option chosen'
export const i19options = 'Options'
export const i19or = 'Or'
export const i19order = 'Order'
export const i19orderDetails = 'Order details'
export const i19orders = 'Orders'
export const i19orderCreated = 'Order created'
export const i19orderConfirmationMsg = 'Your order has been confirmed, thanks for your preference'
export const i19ordersCount = 'Total orders'
export const i19orderCode = 'Order code'
export const i19orderItems = 'Order items'
export const i19orderNotesInputMsg = 'Optional field for customized information or order notes.'
export const i19orderNumber = 'Order number'
export const i19orderObservations = 'Order observations'
export const i19orderStatus = 'Order status'
export const i19orderValue = 'Order value'
export const i19ordersTotalValue = 'Total orders amount completed'
export const i19organization = 'Organization'
export const i19orProceedWith = 'Or proceed with'
export const i19otherCustomers = 'Other customers'
export const i19otherCustomersMsg = 'Available to any customers'
export const i19outOfDate = 'Out of date'
export const i19outOfStock = 'Out of stock'
export const i19ownDelivery = 'Own delivery'
export const i19ownHand = 'Own hand'
export const i19ownHandCost = 'Cost for the "own hand"'
export const i19package = 'Package'
export const i19packageInformation = 'Package information'
export const i19packageDimensions = 'Package dimensions'
export const i19packageDimensionsInformation = 'Package dimensions information'
export const i19packageWeight = 'Package weight'
export const i19pageLoaded = 'Page loaded'
export const i19paid = 'Paid'
export const i19paidTextMsg = 'We are already separating your package. Soon will be sent.'
export const i19parcelIn = 'Parcel in'
export const i19parentCategory = 'Parent category'
export const i19partner = 'Partner'
export const i19partners = 'Partners'
export const i19partnersProgram = 'Partners program'
export const i19passwordChangedSuccessfully = 'Password changed successfully'
export const i19patch = 'Patch'
export const i19payer = 'Payer'
export const i19payment = 'Payment'
export const i19paymentConfirmed = 'Payment Confirmed'
export const i19paymentDetails = 'Payment details'
export const i19paymentError = 'Payment error'
export const i19paymentErrorMsg = 'Unable to approve purchase, please verify details or try another payment method'
export const i19paymentLink = 'Payment link'
export const i19paymentMethod = 'Payment method'
export const i19paymentMethods = 'Payment methods'
export const i19paymentMethodLabel = 'Payment method label'
export const i19paymentOptions = 'Payment options'
export const i19paymentRealized = 'Payment realized'
export const i19personalRegistration = 'Personal registration'
export const i19permalink = 'Permalink'
export const i19perUnit = 'Per unit'
export const i19phone = 'Phone'
export const i19phones = 'Phones'
export const i19photo = 'Photo'
export const i19photos = 'Photos'
export const i19pickup = 'Pickup'
export const i19pickUpAtTheStore = 'Pick up at the store'
export const i19pickUpToday = 'Pick up today'
export const i19picture = 'Picture'
export const i19pictures = 'Pictures'
export const i19pointsEarned = 'Points earned'
export const i19popularProducts = 'Popular products'
export const i19popup = 'Popup'
export const i19post = 'Post'
export const i19posted = 'Posted'
export const i19postingDeadline = 'Deadline for sending the package'
export const i19postingIn = 'Products will be ship within'
export const i19pressEnterToSave = 'Press ENTER to save'
export const i19previous = 'Previous'
export const i19price = 'Price'
export const i19priceAlteration = 'Price alteration'
export const i19priceEffectiveDate = 'How long sale price is valid'
export const i19priceEffectiveDateEnd = 'Promotion end date (ISO 8601)'
export const i19priceEffectiveDateStar = 'Promotion start date (ISO 8601)'
export const i19priceRange = 'Price range'
export const i19priceTo = 'Price to'
export const i19pricing = 'Pricing'
export const i19printBillet = 'Print billet'
export const i19privacy = 'Privacy'
export const i19privacyPolicy = 'Privacy policy'
export const i19private = 'Private'
export const i19privateMetafields = 'Private metafields'
export const i19privateMetafieldsMsg = 'List of custom attributes, hidden by default, visible for the order buyers'
export const i19proceed = 'Proceed'
export const i19product = 'Product'
export const i19productDescription = 'Product description'
export const i19productId = 'Product ID'
export const i19productImages = 'Product images'
export const i19productSpecifications = 'Product specifications'
export const i19productionDeadline = 'Production deadline'
export const i19productionTime = 'Production time'
export const i19productionTimeMsg = 'Deadline for production on pre-ordered product'
export const i19productionTimeCumulative = 'Cumulative production time'
export const i19productionTimeDaysMsg = 'Number of days to produce or handle the product after purchase'
export const i19productionTimeWorkingDays = 'Production time in working days'
export const i19productName = 'Product name'
export const i19products = 'Products'
export const i19productsAdded = 'Added products'
export const i19productsAddedToCart = 'Products added to cart'
export const i19productsPurchased = 'Purchased products'
export const i19profile = 'Profile'
export const i19profileNotFound = 'Profile not found'
export const i19province = 'Province or state name'
export const i19provinceCode = 'Province code'
export const i19put = 'Put'
export const i19quantity = 'Quantity'
export const i19quarterly = 'Quarterly'
export const i19quickSetup = 'Quick setup'
export const i19random = 'Random'
export const i19rating = 'Rating'
export const i19read = 'Read'
export const i19receipt = 'Receipt'
export const i19receiptPrice = 'Price of receipt'
export const i19receivedOrder = 'Received your order!'
export const i19receiveNewsletter = 'Receive newsletter'
export const i19receiveToday = 'Receive today'
export const i19recipient = 'Recipient'
export const i19recommendations = 'Recommendations'
export const i19recommendedForYou = 'Recommended for you'
export const i19recommendedProducts = 'Recommended products'
export const i19recurrence = 'Recurrence'
export const i19recurrent = 'Recurrent'
export const i19redirectToPayment = 'Redirect to payment'
export const i19reference = 'Reference'
export const i19referenceCode = 'Reference code'
export const i19referral = 'Customer invided by'
export const i19referringSite = 'Referring site'
export const i19refine = 'Refine'
export const i19refineSearch = 'Refine search'
export const i19reinstall = 'Reinstall'
export const i19registerDate = 'Register date'
export const i19registerProduct = 'Register product'
export const i19registerToBuy = 'Register to buy'
export const i19registerToBuyMsg = 'Complete your registration to proceed with the purchase'
export const i19registration = 'Registration'
export const i19relatedApps = 'Related apps'
export const i19relatedProduct = 'Related products'
export const i19relatedSearch = 'Related search items'
export const i19releases = 'Releases'
export const i19relevance = 'Relevance'
export const i19remove = 'Remove'
export const i19removed = 'Removed'
export const i19removeFromFavorites = 'Remove from favorites'
export const i19reopenOrder = 'Reopen order'
export const i19require = 'Require'
export const i19required = 'Required'
export const i19requiredEmail = 'Required email'
export const i19requiredEmailMsg = 'Email Completion Required'
export const i19requiredField = 'Required field'
export const i19resource = 'Resource'
export const i19resourceId = 'Resource ID'
export const i19results = 'Results'
export const i19resultsFor = 'Results for'
export const i19retail = 'Retail'
export const i19retry = 'Retry'
export const i19reviews = 'Customer reviews'
export const i19safeEnvMsg = '100% safe environment'
export const i19sales = 'Sales'
export const i19salesPrice = 'Sales price'
export const i19salesChannels = 'Sales channels'
export const i19save = 'Save'
export const i19saveBrand = 'Save brand'
export const i19saveCard = 'Save card'
export const i19saveCart = 'Save cart'
export const i19saveCategory = 'Save category'
export const i19saveClient = 'Save client'
export const i19saved = 'Saved'
export const i19savedWithSuccess = 'Saved with success'
export const i19saveCollection = 'Save collection'
export const i19saveGrid = 'Save grid'
export const i19saveProduct = 'Save product'
export const i19saveText = 'Save text'
export const i19scheduledDelivery = 'Scheduled delivered'
export const i19search = 'Search'
export const i19searchAgain = 'Search again'
export const i19searchEngineListing = 'Search engine listing'
export const i19searchingFor = 'Searching for'
export const i19searchItems = 'Search items'
export const i19searchOfflineErrorMsg = 'Couldn\'t perform search, please check your internet connection.'
export const i19searchProducts = 'Search products'
export const i19securityCode = 'Security code'
export const i19seeAll = 'See all'
export const i19seeAllApps = 'See all apps'
export const i19seeAllThemes = 'See all themes'
export const i19seeAll$1Category = 'See all $1 category'
export const i19seeCart = 'See cart'
export const i19seeMore = 'See more'
export const i19seeMoreCategories = 'See more categories'
export const i19seeMoreInfo = 'See more info'
export const i19seeOrder = 'See order'
export const i19seeShoppingCart = 'See shopping cart'
export const i19select = 'Select'
export const i19selected = 'Selected'
export const i19selectedOffers = 'Selected Offers'
export const i19selectedOptions = 'Selected options'
export const i19selectVariation = 'Select variation'
export const i19selectVariationMsg = 'Please select an option in each field above'
export const i19seller = 'Seller'
export const i19sellerRecommendations = 'Seller recommendations'
export const i19sellerRecommendationsProducts = 'Seller recommendation products'
export const i19sellerRecommendationsTitle = 'Seller recommendation title'
export const i19sellerStatus = 'Order status created by seller'
export const i19send = 'Send'
export const i19sender = 'Sender'
export const i19senderFrom = 'Sender\'s address'
export const i19sendLoginCodeByEmail = 'Send login code by email'
export const i19seo = 'SEO'
export const i19setDomainMsg = 'You must be the owner of the domain and point it to the store.'
export const i19setStoreDomain = 'Set store domain'
export const i19settings = 'Settings'
export const i19setUp = 'Set up'
export const i19share = 'Share'
export const i19shareOnFacebook = 'Share on Facebook'
export const i19shareOnWhatsapp = 'Share on Whatsapp'
export const i19shipped = 'Shipped'
export const i19shippedBy = 'Shipped by'
export const i19shipping = 'Shipping'
export const i19shippingAdditionalPrice = 'Shipping additional price'
export const i19shippingAddress = 'Shipping address'
export const i19shippingCustomFields = 'Shipping custom fields'
export const i19shippingDiscount = 'Shipping discount'
export const i19shippingInvoices = 'Shipping invoices'
export const i19shippingMethod = 'Shipping Method'
export const i19shippingMethodLabel = 'Shipping method label'
export const i19shippingNotes = 'Shipping notes'
export const i19shippingNotesMsg = 'Additional information about shipping'
export const i19shippingStatus = 'Shipping status'
export const i19shippingTag = 'Shipping tag'
export const i19shippingTags = 'Shipping tags'
export const i19shippingTaxes = 'Shipping taxes'
export const i19shippingTaxesMsg = 'List of additional services for this shipping line'
export const i19shippingTo = 'Shipping to'
export const i19shippingTotalCost = 'Shipping total cost'
export const i19shopByCategory = 'Shop by category'
export const i19shopByFranchise = 'Shop by franchise'
export const i19shopNow = 'Shop now'
export const i19shoppingCart = 'Shopping cart'
export const i19short = 'Short'
export const i19shortDescription = 'Short description'
export const i19show = 'Show'
export const i19showDescription = 'Show full description'
export const i19showReview = 'Show full review'
export const i19signIn = 'Sign in'
export const i19signInWith = 'Sign in with'
export const i19signInWithAnotherEmail = 'Sign in with another email'
export const i19signUp = 'Sign Up'
export const i19signUpWith = 'Sign up with'
export const i19signature = 'Signature'
export const i19size = 'Size'
export const i19sizeGuide = 'Size guide'
export const i19sku = 'SKU'
export const i19slug = 'Slug'
export const i19socialLogin = 'Social login'
export const i19socialMedia = 'Social media'
export const i19source = 'Source'
export const i19sourceName = 'Name of order origin'
export const i19sort = 'Sort'
export const i19sortBy = 'Sort by'
export const i19subscribe = 'Subscribe'
export const i19subscription = 'Subscription'
export const i19subscriptionInvoices = 'Subscription invoices'
export const i19subscriptions = 'Subscriptions'
export const i19submit = 'Submit'
export const i19suggestedProducts = 'Suggested products'
export const i19specifications = 'Specifications'
export const i19staffNotes = 'Staff notes'
export const i19staffSignature = 'Created by staff'
export const i19star = 'Star'
export const i19startDate = 'Start date'
export const i19state = 'State'
export const i19status = 'Status'
export const i19statusLink = 'URL to order status page'
export const i19statusMobileLink = 'URL to order status page for mobile'
export const i19street = 'Street'
export const i19store = 'Store'
export const i19storefront = 'Storefront'
export const i19subresource = 'Subresource'
export const i19subresourceId = 'Subresource ID'
export const i19subtitle = 'Subtitle for SEO purpose'
export const i19subtotal = 'Subtotal'
export const i19success = 'Success'
export const i19successfullyInstalled = 'Successfully installed'
export const i19successfullyUninstalled = 'Successfully uninstalled'
export const i19summary = 'Summary'
export const i19support = 'Support'
export const i19table = 'Table'
export const i19tax = 'Tax'
export const i19taxExempt = 'Tax exempt'
export const i19termSearched = 'Term searched'
export const i19test = 'Test'
export const i19thanks = 'Thanks!'
export const i19thanksForPurchase = 'Thank you for your purchase'
export const i19theme = 'Theme'
export const i19themes = 'Themes'
export const i19ticketCode = 'Ticket code'
export const i19title = 'Title'
export const i19titleTag = 'Title tag'
export const i19to = 'To'
export const i19toEarn = 'To earn'
export const i19toPay = 'To pay'
export const i19today = 'Today'
export const i19token = 'Token'
export const i19total = 'Total'
export const i19totalAmount = 'Total amount'
export const i19totalCancelled = 'Total cancelled'
export const i19totalCancelledMsg = 'Total of orders cancelled'
export const i19totalResultsFor = 'Products found for'
export const i19totalSpent = 'Total spent by custumer'
export const i19trackDelivery = 'Track delivery'
export const i19trackingCodes = 'Tracking codes'
export const i19transactionCode = 'Transaction code'
export const i19transactionId = 'Transaction ID'
export const i19transactionItems = 'List of items transaction'
export const i19transactionStatus = 'Transaction status'
export const i19transactionStatusMsg = 'Data and hour of changed status'
export const i19transactionType = 'Transaction type'
export const i19trendingApps = 'Trending apps'
export const i19triggers = 'Triggers'
export const i19triggersMsg = 'List of events that call this procedure'
export const i19tryAgain = 'Try again'
export const i19type = 'Type'
export const i19unable = 'Unable'
export const i19unableToInstallApp = 'Unable to install app'
export const i19unableToUninstallApp = 'Unable to uninstall app'
export const i19unavailable = 'Unavailable'
export const i19uninstall = 'Uninstall'
export const i19uninstallingApp = 'Uninstalling app'
export const i19uninstallingAppWithSuccess = 'Uninstalling app with success'
export const i19units = 'Units'
export const i19unitsInStock = 'Units in stock'
export const i19unlimited = 'Unlimited'
export const i19untilTomorrow = 'Until tomorrow'
export const i19unsubscribe = 'Unsubscribe'
export const i19update = 'Update'
export const i19updatedAt = 'Updated at'
export const i19upload = 'Upload'
export const i19uploadLogo = 'Upload logo'
export const i19uploadTable = 'Upload table'
export const i19upTo = 'Up to'
export const i19user = 'User'
export const i19userFound = 'User found'
export const i19username = 'Username'
export const i19usersFound = 'Users found'
export const i19use$1LoyaltyPoints = 'Use $1 loyalty points'
export const i19utm = 'Utm'
export const i19utmCampaign = 'Utm campaign'
export const i19utmContent = 'Utm content'
export const i19utmMedium = 'Utm medium'
export const i19utmSource = 'Utm source'
export const i19utmTerm = 'Utm term'
export const i19url = 'Url'
export const i19valid = 'Valid'
export const i19validate = 'Validate'
export const i19validThru = 'Valid thru'
export const i19value = 'Value'
export const i19variation = 'Variation'
export const i19variationId = 'Variation ID'
export const i19variationName = 'Variation name'
export const i19variations = 'Variations'
export const i19verified = 'Verified'
export const i19version = 'Version'
export const i19versionDate = 'Version date'
export const i19video = 'Video'
export const i19videos = 'Videos'
export const i19visible = 'Visible'
export const i19visibleProducts = 'Visible products'
export const i19visitor = 'Visitor'
export const i19visitorCheckout = 'You can also buy as a visitor if you prefer'
export const i19warning = 'Warning'
export const i19warningToReinstallAppMsg = 'When reinstalling, you will need to configure the application again.'
export const i19wasAnErrorOnLoginMsg = 'There was an error trying to login, please try again or select another option'
export const i19webhooks = 'Webhook'
export const i19webhooksMsg = 'List of notifications to be sent'
export const i19webhooksApiMsg = 'API where notification should be sent'
export const i19webhooksApiExternalApiMsg = 'Use this property if webhook is to any external API (not api.e-com.plus)'
export const i19webhooksApiStoreApiMsg = 'Use this property if webhook is to store API (api.e-com.plus)'
export const i19webhooksMapBodyMsg = 'Object to send, it is possible to use variables as properties values'
export const i19webhooksSendBodyMsg = 'If true, send body in to notification. If map_body is undefined, trigger object will be sent'
export const i19weekly = 'Weekly'
export const i19weight = 'Weight'
export const i19weFrom = 'We from'
export const i19welcome = 'Welcome'
export const i19welcomeTextMsg = 'We are happy with your registration. Take a look at our products!'
export const i19weRecommendToYou = 'We recommend for you'
export const i19weUseYourDataToMsg = 'We will use your data safely and responsibly to'
export const i19widgets = 'Widgets'
export const i19width = 'Width'
export const i19willReceiveMsg = 'You\'ll receive the products in up to'
export const i19with = 'With'
export const i19withoutInstallmentRates = 'Without installment rates'
export const i19write = 'Write'
export const i19writeReview = 'Write a review'
export const i19workingDays = 'Working days'
export const i19year = 'Year'
export const i19yearly = 'Yearly'
export const i19years = 'Years'
export const i19yes = 'Yes'
export const i19youEarn = 'You earn'
export const i19yourInstalledApps = 'Your installed apps'
export const i19zipCode = 'Zip code'
export const i19zipCodeRange = 'Zip code range'

export const i19CancelReason = {
  customer: 'Cancelled by customer',
  fraud: 'Cancelled for fraud',
  inventory: 'Cancelled due to out of stock',
  declined: 'Canceled by credit card company',
  other: 'Other reason'
}

export const i19ChannelType = {
  ecommerce: 'Ecommerce',
  mobile: 'Mobile',
  pos: 'POS',
  button: 'Button',
  facebook: 'Facebook',
  chatbot: 'Chatbot'
}

export const i19CommodityType = {
  physical: 'Physical',
  digital: 'Digital'
}

export const i19ProductCondition = {
  new: 'New',
  refurbished: 'Refurbished',
  used: 'Used',
  not_specified: 'Not specified'
}

export const i19DiscountApplyAt = {
  total: 'Total',
  subtotal: 'Subtotal',
  freight: 'Freight'
}

export const i19DiscountType = {
  percentage: 'Percentage',
  fixed: 'Fixed'
}

export const i19FinancialStatus = {
  pending: 'Pending payment',
  under_analysis: 'Payment under analysis',
  authorized: 'Authorized payment',
  unauthorized: 'Unauthorized payment',
  partially_paid: 'Partially paid',
  paid: 'Paid',
  dispute: 'Payment in dispute',
  partially_refunded: 'Payment partially refunded',
  refunded: 'Payment refunded',
  voided: 'Payment voided',
  unknown: 'Unknown payment status'
}

export const i19FinancialStatusMsg = {
  pending: 'Your order have',
  under_analysis: 'Your order have',
  authorized: 'Your order have',
  unauthorized: 'Your order have',
  partially_paid: 'Your order is',
  paid: 'Your order have',
  dispute: 'Your order have',
  partially_refunded: 'Your order have',
  refunded: 'Your order have',
  voided: 'Your order have',
  unknown: 'Your order have'
}

export const i19FulfillmentStatus = {
  ready_for_shipping: 'Ready for shipping',
  shipped: 'Shipped',
  delivered: 'Delivered',
  invoice_issued: 'Invoice issued',
  in_production: 'In production',
  in_separation: 'In separation',
  partially_shipped: 'Partially shipped',
  partially_delivered: 'Partially delivered',
  returned_for_exchange: 'Returned for exchange',
  received_for_exchange: 'Received for exchange',
  returned: 'Returned'
}

export const i19FulfillmentStatusMsg = {
  ready_for_shipping: 'Your order is',
  shipped: 'Your order was',
  delivered: 'Your order was',
  invoice_issued: 'Your',
  in_production: 'Your order is',
  in_separation: 'Your order is',
  partially_shipped: 'Your order was',
  partially_delivered: 'Your order was',
  returned_for_exchange: 'Your order had',
  received_for_exchange: 'Your order was',
  returned: 'Your order was'
}

export const i19Gender = {
  f: 'Female',
  m: 'Male',
  x: 'X'
}

export const i19InscriptionType = {
  State: 'State',
  Municipal: 'Municipal'
}

export const i19OrderStatus = {
  open: 'Open order',
  closed: 'Finalized order',
  cancelled: 'Cancelled'
}

export const i19PaymentMethodCodes = {
  credit_card: 'Credit card',
  banking_billet: 'Banking billet',
  online_debit: 'Online debit',
  account_deposit: 'Account deposit',
  debit_card: 'Debit card',
  balance_on_intermediary: 'Balance on intermediary',
  loyalty_points: 'Loyalty points',
  other: 'Other'
}

export const i19PaymentsHistoryStatus = {
  pending: 'Pending payment',
  under_analysis: 'Payment under analysis',
  authorized: 'Authorized payment',
  unauthorized: 'Unauthorized payment',
  partially_paid: 'Partially paid',
  paid: 'Paid',
  dispute: 'Payment in dispute',
  partially_refunded: 'Payment partially refunded',
  refunded: 'Payment refunded',
  voided: 'Payment voided',
  unknown: 'Unknown payment status'
}

export const i19PhoneType = {
  home: 'Home',
  personal: 'Personal',
  work: 'Work',
  other: 'Other'
}

export const i19RegistryType = {
  p: 'Physical',
  j: 'Juridical'
}

export const i19ShippingLinesStatus = {
  ready_for_shipping: 'Ready for shipping',
  shipped: 'Shipped',
  delivered: 'Delivered',
  invoice_issued: 'Invoice issued',
  in_production: 'In production',
  in_separation: 'In separation',
  partially_shipped: 'Partially shipped',
  partially_delivered: 'Partially delivered',
  returned_for_exchange: 'Returned for exchange',
  received_for_exchange: 'Received for exchange',
  returned: 'Returned'
}

export const i19StateRegister = {
  invited: 'Invited',
  registered: 'Registered',
  declined: 'Declined'
}

export const i19TransactionsType = {
  payment: 'Payment',
  recurrence: 'Recurrence'
}

export const i19ApiActions = {
  create: 'Create',
  change: 'Change',
  delete: 'Delete'
}

export const i19StoreApiResources = {
  authentications: 'Authentications',
  products: 'Products',
  categories: 'Categories',
  brands: 'Brands',
  collections: 'Collections',
  grids: 'Grids',
  customers: 'Customers',
  carts: 'Carts',
  orders: 'Orders',
  applications: 'Applications',
  stores: 'Stores',
  procedures: 'Procedures',
  triggers: 'Triggers'
}
